import SDGIcon from "../../components/Sustainability/SDGIcon/SDGIcon";
import React, { useState, useEffect, useContext } from "react";
import { Popover } from "antd";
import { openkit } from "../../library/database";
import { AppContext } from "../../context";

const contentStyle = {
  padding: 10,
};

function VillageIndicators({ villageSlug }) {
  const [indicators, setIndicators] = useState({});
  const [indicatorIcons, setIndicatorIcons] = useState({});
  const info = useContext(AppContext);
  console.log("info :>> ", info);
  useEffect(() => {
    (async () => {
      try {
        villageSlug = villageSlug.replace("-", "_");
        const res = await openkit.data.findOne("c_villages", {
          slug: villageSlug,
        });
        setIndicators(res.indicators);

        const icons_url = await openkit.data.find("indicator_icons");
        setIndicatorIcons({
          accessibility: icons_url.find((el) => el.name === "accessibility")
            .link,
          atm: icons_url.find((el) => el.name === "atm").link,
          biosphere: icons_url.find((el) => el.name === "biosphere").link,
          wifi: icons_url.find((el) => el.name === "wifi").link,
          secure_destiny: icons_url.find((el) => el.name === "secure_destiny")
            .link,
        });
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        padding: 5,
        backgroundColor: "rgba(0,0,0,0.8)",
      }}
    >
      <Popover
        content={
          <div style={contentStyle}>
            Biosphere: {indicators?.biosphere * 25}%
          </div>
        }
      >
        {/* for some reason, for popover to activate, it is needed the following space */}{" "}
        <SDGIcon
          imageUrl={indicatorIcons["biosphere"]}
          bars={indicators?.biosphere}
          iconWidth={60}
        />
      </Popover>
      <Popover
        content={
          <div style={contentStyle}>
            {info.t("wifi")}: {indicators?.wifi * 25}%
          </div>
        }
      >
        {" "}
        <SDGIcon
          imageUrl={indicatorIcons["wifi"]}
          bars={indicators?.wifi}
          iconWidth={60}
        />
      </Popover>
      <Popover
        content={
          <div style={contentStyle}>
            {info.t("safeDestiny")}: {indicators?.secure_destiny * 25}%
          </div>
        }
      >
        {" "}
        <SDGIcon
          imageUrl={indicatorIcons["secure_destiny"]}
          bars={indicators?.secure_destiny}
          iconWidth={60}
        />
      </Popover>
      <Popover
        content={
          <div style={contentStyle}>
            {info.t("atm")}: {indicators?.atm * 25}%
          </div>
        }
      >
        {" "}
        <SDGIcon
          imageUrl={indicatorIcons["atm"]}
          bars={indicators?.atm}
          iconWidth={60}
        />
      </Popover>
      <Popover
        content={
          <div style={contentStyle}>
            {info.t("accessibility")}: {indicators?.accessibility * 25}%
          </div>
        }
      >
        {" "}
        <SDGIcon
          imageUrl={indicatorIcons["accessibility"]}
          bars={indicators?.accessibility}
          iconWidth={60}
        />
      </Popover>
    </div>
  );
}

export default VillageIndicators;
